import AdvancedController from "./advanced-controller"
import { fadeIn, fadeOut } from '../animations/animation-fade'

import { Breakpoints } from "../utils/breakpoints";


const NAV_TOGGLE_BREAKPOINT = 'sm'

export default class HeaderController extends AdvancedController {

    static values = {
        isNavToggled: Boolean,
        isSearchToggled: Boolean,
    }

    static targets = [
        "navToggle",
        "searchForm",
        "searchField",
        "searchToggleButton",
        "search",
    ]

    connect() {
        super.connect();
        this.navMainTarget = document.getElementById('nav-main');
        this.navMainTargetUl = document.getElementById('nav-main').querySelector('ul');
        this.navSecondaryTarget = document.getElementById('nav-secondary');
        this.navSecondaryTargetUl = this.navSecondaryTarget.querySelector('ul');
        this.navTertiaryTarget = document.getElementById('nav-tertiary');
        this.navTertiaryTargetUl = this.navTertiaryTarget.querySelector('ul');

        this.breakpoints = new Breakpoints();
        // outside click close
        window.addEventListener('click', (e) => {
            if (this.isSearchToggledValue && !this.searchFormTarget.contains(e.target) && !this.searchToggleButtonTarget.contains(e.target)) {
                this.isSearchToggledValue = false
                this._handleState();
            }
        })
        this.resize();

    }

    resize() {

        if (this.breakpoints.breakpointDown(NAV_TOGGLE_BREAKPOINT)) {
            this.navToggleTarget.parentElement.append(this.searchTarget);
            this.navSecondaryTargetUl.classList.add('-moved-menu');
            this.navTertiaryTargetUl.classList.add('-moved-menu');
            this.navMainTarget.append(this.navSecondaryTargetUl);
            this.navMainTarget.append(this.navTertiaryTargetUl);
        } else {
            if (this.navSecondaryTargetUl.classList.contains('-moved-menu') && this.navTertiaryTargetUl.classList.contains('-moved-menu')) {
                this.navSecondaryTarget.append(this.navMainTarget.querySelector('.-moved-menu'));
                this.navTertiaryTarget.append(this.navMainTarget.querySelector('.-moved-menu'));
                this.navSecondaryTarget.children[0].classList.remove('-moved-menu');
                this.navTertiaryTarget.children[0].classList.remove('-moved-menu');
                this.navTertiaryTarget.parentElement.append(this.searchTarget);
            }
        }
    }


    onToggleClick(e) {
        e.preventDefault();
        this.isNavToggledValue = !this.isNavToggledValue;
        if (this.isNavToggledValue) this.isSearchToggledValue = false
        this._handleState();
    }

    onSearchToggle(e) {
        e.preventDefault();
        this.isSearchToggledValue = !this.isSearchToggledValue;
        if (this.isSearchToggledValue) this.isNavToggledValue = false
        this._handleState();
    }

    _handleClasses() {
        this.element.classList.toggle('-nav-toggled', this.isNavToggledValue)
        this.element.classList.toggle('-search-toggled', this.isSearchToggledValue)
    }

    _handleState() {
        this._handleClasses();

        if (this.isNavToggledValue) {
            this.navMainTarget.style.display = "flex"
        } else {
            this.navMainTarget.style.display = "none"
        }
        if (this.hasSearchFormTarget) {
            if (this.isSearchToggledValue) {
                this.searchFormTarget.style.display = "flex"
                this.searchFieldTarget.focus()
            } else {
                this.searchFormTarget.style.display = "none"
            }
        }
    }

    messageCloseNav() {
        for (const controller of this.getAllControllers("nav-main-sub-menu")) {
            controller.messageClose();
        }
        this.isNavToggledValue = false
        this._handleState();
    }
}